import * as React from 'react';
import { Layout } from '../Components/Layout';
import { setDrawerContent, setPageContent, hideDrawer } from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import { IApplicationState, IConnectedReduxProps } from '../Store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { FormulaireContent } from '../Components/Declarations/Formulaire';
import { RouterState } from 'connected-react-router';
import { IUserState } from '../Store/User/Types';
import { AdminPreview } from '../Components/Declarations/AdminPreview';

interface IPropsFromState {
    router: RouterState;
    user: IUserState;
}

interface IState {
    bucketId: number;
    fgpId: number;
    userGroupId: number;
}


interface IPropsFromDispatch {
    setDrawerContent: typeof setDrawerContent;
    setPageContent: typeof setPageContent;
    hideDrawer: typeof hideDrawer;
}

type AllProps =
    IPropsFromState &
    IPropsFromDispatch &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

export class FormulairePageComponent extends React.Component<AllProps, IState> {

    public constructor(props: AllProps) {
        super(props);
        this.state = {
            bucketId: 0,
            fgpId: 0,
            userGroupId: 0,
        }
    }

    public componentDidMount() {
        const pathstate = this.extractIdFomPath(this.props.router.location.pathname);

        if (pathstate === null) {
            this.setState({
                bucketId: 0,
                fgpId: 0,
                userGroupId: 0,
            });
        } else {
            this.setState({
                bucketId: pathstate.bucketId,
                fgpId: pathstate.fgpId,
                userGroupId: pathstate.userGroupId,
            });
        }

        this.props.hideDrawer();
        if (this.props.user.userInfo.parent_info.id !== pathstate?.userGroupId) {
            this.props.setPageContent(<Route component={(props: any) => <AdminPreview {...props} bucketId={this.state.bucketId} fgpId={this.state.fgpId} userGroupId={this.state.userGroupId} />} />);
        } else {
            this.props.setPageContent(<Route component={(props: any) => <FormulaireContent {...props} bucketId={this.state.bucketId} fgpId={this.state.fgpId} userGroupId={this.state.userGroupId} />} />);
        }

    }

    private extractIdFomPath = (pathname: string) => {
        const ids = pathname.match(/\d+/g);
        if (ids !== null && ids.length === 3) {
            const bucketId = parseInt(ids[0]);
            const fgpId = parseInt(ids[1]);
            const userGroupId = parseInt(ids[2]);
            if (bucketId && fgpId && userGroupId) {
                return {
                    bucketId: bucketId,
                    fgpId: fgpId,
                    userGroupId: userGroupId,
                }
            }
        }
        return null;
    }

    public render(): React.ReactNode {
        if (this.state.bucketId === 0 || this.state.fgpId === 0 || this.state.userGroupId === 0) {
            return <Route component={() => <div>Not Found</div>} />
        }
        return (
            <Route component={Layout} />
        );
    }
}

const mapStateToProps = ({ router, user }: IApplicationState) => ({
    router,
    user
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
    setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
    hideDrawer: () => dispatch(hideDrawer()),
});

export const FormulairePage = connect(mapStateToProps, mapDispatchToProps)(FormulairePageComponent);
